// extracted by mini-css-extract-plugin
module.exports = {"image":"xR","loaded":"yR","placeholder":"zR"};